import { register, CloudObject, defineProperty, defineRelation, Direction, File as OFile } from 'olympe';
import InspectionEntity from "./InspectionEntity";

/**
 * @extends {CloudObject}
 */
export default class Feedback extends CloudObject {

    /**
     * @return {string}
     */
    getComment() {
        return this.get(Feedback.commentProp);
    }
}

// Hardcoded tags
register('01880fba7ff5af5bb448', Feedback);
Feedback.commentProp = defineProperty('01880fbb6f0c7c73c456');
Feedback.targetRel = defineRelation('01880fbba294002b16c5', Feedback, InspectionEntity);
Feedback.documentsRel = defineRelation('01880fbbc35406239628', Feedback, OFile);
Feedback.inverse_unitfeedbacksRel = defineRelation('0188d02d2c8d18935c6c', Direction.ORIGIN);
Feedback.inverse_systemfeedbackRel = defineRelation('0188fc02f3398bf5257e', Direction.ORIGIN);
